// import { createSelector } from 'reselect';

export const getApplicationId = (state:any) => state.setting.squareApplicationId;
export const getLocationId = (state:any) => state.setting.squareLocationId;

export const getMembershipModuleEnabled = (state:any) => state.setting.membershipModuleEnabled;
export const getRemotelockIntegrationLocked = (state:any) => state.setting.remotelockIntegrationEnabled;
